/** @jsxImportSource @emotion/react */
import React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { ProgressBar } from './ProgressBar';
import { BirdiTheme } from '@birdi/theme';

interface UsageSectionProps {
  seatsCurrent: number;
  seatsTotal: number | string;
  guestsCurrent: number;
  guestsTotal: number;
  processingUsed: number;
  processingTotal: number;
  storageUsed: number;
  storageTotal: number;
  workspacesUsed: number;
  workspacesTotal: number;
  whiteBorder: boolean;
}

export const UsageSection: React.FC<UsageSectionProps> = ({
  seatsCurrent,
  seatsTotal,
  guestsCurrent,
  guestsTotal,
  processingUsed,
  processingTotal,
  storageUsed,
  storageTotal,
  workspacesUsed,
  workspacesTotal,
  whiteBorder = true,
  interval = 'month',
}) => {
  return (
    <div
      css={(theme: BirdiTheme) => css`
        border-radius: 8px;
        padding: 1.5em;
        margin-bottom: 2em;
        border: 1px solid ${whiteBorder ? '#ccc' : theme.mono30};
      `}
    >
      <h3
        css={css`
          margin-top: 0;
          margin-bottom: 1em;
        `}
      >
        Current Usage
      </h3>

      <div
        css={css`
          display: grid;
          grid-template-columns: 1fr;
          gap: 1.5em;
        `}
      >
        <ProgressBar
          label="Seats"
          current={seatsCurrent}
          total={seatsTotal}
          isUnlimited={seatsTotal === 'Unlimited'}
        />

        <ProgressBar
          label={`Processing Credit (${interval === 'month' ? 'per month' : 'per year'})`}
          current={processingUsed}
          total={processingTotal}
          unit=" GP"
        />

        <ProgressBar
          label="Guests"
          current={guestsCurrent}
          total={guestsTotal}
          isUnlimited={false}
        />

        <ProgressBar
          label="Storage"
          current={parseFloat(storageUsed.toFixed(2))}
          total={storageTotal}
          unit=" GB"
        />

        <ProgressBar
          label="Workspaces"
          current={workspacesUsed}
          total={workspacesTotal}
        />

        <span
          css={css`
            font-size: 0.9rem;
            margin-top: 0em;
          `}
        >
          Reached your current limit?{' '}
          <a href="mailto:support@birdi.io">Contact us</a> or{' '}
          <a href="/billing/options">upgrade</a> to expand your capacity. Usages
          for growth and ultimate plans are updated every 24 hours.
        </span>
      </div>
    </div>
  );
};
